import { ElementStringIcon, IconType } from './elementIconTypes';

export default (string: string, idPrefix = 'str'): ElementStringIcon => ({
    type: IconType.STRING,
    id: `${idPrefix}-${string}`,
    string: string.toUpperCase(),
});
